import { render, staticRenderFns } from "./premium.vue?vue&type=template&id=14f1d915"
import script from "./premium.vue?vue&type=script&lang=js"
export * from "./premium.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Heading: require('/build/components/Heading.vue').default,Card: require('/build/components/Card.vue').default,CardPremium: require('/build/components/CardPremium.vue').default})
